import React, { useState, useEffect } from "react";
import { Formik, Field, FieldArray } from "formik";
import { Form, Button } from "react-bootstrap";
import { get, isEmpty, isNaN } from "lodash";
import moment from "moment";
import {
  FieldButtonGroup,
  SliderPanel,
  FieldDropSide,
  SearchDrop,
  FieldInput,
  DatePicker,
} from "../../../components";
import { toOptionValuesFromMapper, usDateFormat } from "../../../utils";
import { SourceFieldComponent } from "./SourceFieldComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-csharp";
import "ace-builds/src-noconflict/theme-terminal";
import "ace-builds/src-noconflict/ext-language_tools";
import functionList from "./FunctionList.js";
import { Result } from "./Result";
const initialValues = [];

function isNumber(searchValue) {
  if (typeof searchValue == "string") {
    var found = searchValue.search(/^(\d*\.?\d*)$/);
    if (found > -1) {
      return true;
    } else {
      return false;
    }
  }
  return false;
}

const functionData = functionList.map((fun, ind) => {
  const codeBlock =
    fun.numberOfParameters == 0
      ? []
      : fun.numberOfParameters == 1
      ? [0]
      : [0, 1];
  return { ...fun, label: fun.displayedName, value: ind, codebox: codeBlock };
});

const dataTypes = [
  {
    label: "string",
    value: 1,
  },
  {
    value: 2,
    label: "number",
  },
  {
    value: 3,
    label: "date",
  },
];

const fields = {
  pickDataFrom: "pickDataFrom",
  function: "function",
  code: "code",
};
const valueType = {
  1: "Value",
  2: "Header",
  3: "Constant",
  6: "Variable",
};
export const ConfigureTransformations = (props) => {
  const {
    addFieldSlider,
    onCancel,
    itemConfigure,
    setFieldSlider,
    configuredValues,
    setTargetField,
    initialData,
    fileName,
  } = props;
  const [ShowEditorConsole, setShowEditorConsole] = useState(false);
  const [editorConsoleCode, setEditorConsoleCode] = useState("");

  const [updatevalue, setupdatevalue] = useState(0);
  function useForceUpdate() {
    return () => setupdatevalue((updatevalue) => updatevalue + 1);
  }
  const item = !isEmpty(itemConfigure) && itemConfigure.object;
  const itemMapped = !isEmpty(itemConfigure) && itemConfigure.objectMap;
  const itemId = !isEmpty(itemConfigure) && itemConfigure.id;
  const functionsData = get(item, "fieldOperations", []);
  const pickDataFromInitialValue = get(configuredValues, "dataSource", 1);
  const functionTransformedData =
    !isEmpty(functionsData) &&
    !isEmpty(functionsData[0].transformation) &&
    functionsData.map((e, i) => {
      const trans = e.transformation
        ? e.transformation.split("(").join(",").split(")").join(",").split(",")
        : "";
      let indexOfTheFunction = functionList
        .map((f) => f.displayedName)
        .indexOf(trans[0]);
      let transFunctions = null;
      let commareplacelookup =
        trans[0] === "ReplaceLookup" &&
        trans.length - 4 ===
          functionList[indexOfTheFunction].numberOfParameters + 1;
      let commaSplit =
        trans[0] === "Split" &&
        trans.length - 3 ===
          functionList[indexOfTheFunction].numberOfParameters + 1;
      if (
        !isNaN(indexOfTheFunction) &&
        indexOfTheFunction >= 0 &&
        indexOfTheFunction < functionList.length
      ) {
        transFunctions =
          functionList[indexOfTheFunction].numberOfParameters == 0
            ? {
                id: e.id,
                objectMapId: e.objectMapId,
                function: trans[0],
                returnDataType: functionList[indexOfTheFunction].returnDataType,
              }
            : functionList[indexOfTheFunction].numberOfParameters == 1
            ? {
                id: e.id,
                objectMapId: e.objectMapId,
                function: trans[0],
                code0: trans[2],
                returnDataType: functionList[indexOfTheFunction].returnDataType,
              }
            : functionList[indexOfTheFunction].numberOfParameters == 2
            ? {
                id: e.id,
                objectMapId: e.objectMapId,
                function: trans[0],
                code0: commaSplit
                  ? "','"
                  : commareplacelookup
                  ? [trans[2], trans[3]]
                  : trans[2],
                code1: commaSplit
                  ? trans[4]
                  : commareplacelookup
                  ? [trans[4], trans[5]]
                  : trans[3],
                returnDataType:
                  functionList[
                    functionList.map((f) => f.displayedName).indexOf(trans[0])
                  ].returnDataType,
              }
            : null;
      }
      return transFunctions;
    });
  const switchView = (
    functionName = "",
    input_value = "",
    arg1 = "",
    arg2,
    itemMapped
  ) => {
    let returnObject = {
      result: null,
    };
    let nullByPassFunctions = ["defaultoption"];
    if (
      !input_value &&
      !nullByPassFunctions.includes(functionName.toLowerCase())
    )
      return returnObject;
    switch (functionName.toLowerCase()) {
      case "abs":
        returnObject = {
          code: "abs",
          result: !isNaN(input_value) ? Math.abs(parseInt(input_value)) : "",
        };
        break;

      case "divide":
        returnObject = {
          code: "divide",
          result:
            !isNaN(parseFloat(input_value)) && !isNaN(parseFloat(arg1))
              ? parseFloat(input_value) / parseFloat(arg1)
              : "",
        };
        break;

      case "ceil":
        returnObject = {
          code: "ceil",
          result: !isNaN(parseFloat(input_value))
            ? Math.ceil(parseFloat(input_value))
            : "",
        };
        break;

      case "strip":
        returnObject = {
          code: "strip",
          result: input_value.split(arg1.slice(1, -1)).join(""),
        };
        break;

      case "floor":
        returnObject = {
          code: "floor",
          result: !isNaN(parseFloat(input_value))
            ? Math.floor(parseFloat(input_value))
            : "",
        };
        break;

      case "max":
        returnObject = {
          code: "max",
          result:
            !isNaN(parseFloat(input_value)) && !isNaN(parseFloat(arg1))
              ? Math.max(parseFloat(input_value), parseFloat(arg1))
              : "",
        };
        break;

      case "min":
        returnObject = {
          code: "min",
          result:
            !isNaN(parseFloat(input_value)) && !isNaN(parseFloat(arg1))
              ? Math.min(parseFloat(input_value), parseFloat(arg1))
              : "",
        };
        break;

      case "modulo":
        returnObject = {
          code: "modulo",
          result:
            !isNaN(parseFloat(input_value)) && !isNaN(parseFloat(arg1))
              ? parseFloat(input_value) % parseFloat(arg1)
              : "",
        };
        break;

      case "sum":
        returnObject = {
          code: "sum",
          result:
            !isNaN(parseFloat(input_value)) && !isNaN(parseFloat(arg1))
              ? parseFloat(input_value) + parseFloat(arg1)
              : "",
        };
        break;

      case "tonumber":
        returnObject = {
          code: "tonumber",
          result: !isNumber(input_value) ? "" : parseInt(input_value),
        };
        break;

      case "indexof":
        returnObject = {
          code: "indexof",
          result: input_value.indexOf(arg1.slice(1, -1)),
        };
        break;

      case "numbertostring":
        returnObject = {
          code: "NumberToString",
          result: !isNaN(input_value) ? input_value.toString() : "",
        };
        break;

      case "convertemptystringtonull":
        returnObject = {
          code: "ConvertEmptyStringToNull",
          result: input_value == "" ? null : input_value,
        };
        break;
      case "padleading":
        returnObject = {
          code: "PadLeading",
          result:
            typeof input_value == "string"
              ? input_value.padStart(parseInt(arg1), arg2)
              : "",
        };
        break;
      case "padtrailing":
        returnObject = {
          code: "PadTrailing",
          result:
            typeof input_value == "string"
              ? input_value.padEnd(parseInt(arg1), arg2)
              : "",
        };
        break;

      case "length":
        returnObject = {
          code: "Length",
          result: typeof input_value == "string" ? input_value.length : "",
        };
        break;

      case "split":
        let temp_2 = "";
        if (typeof input_value == "string" && isNumber(arg2)) {
          let temp_1 = input_value.split(arg1.slice(1, -1));
          temp_2 =
            parseInt(arg2) < temp_1.length && parseInt(arg2) >= 0
              ? temp_1[parseInt(arg2)]
              : "";
        }
        returnObject = {
          code: "Split",
          result: temp_2,
        };
        break;

      case "substring":
        returnObject = {
          code: "Substring",
          result:
            typeof input_value == "string" && isNumber(arg1) && isNumber(arg2)
              ? input_value.substring(
                  parseInt(arg1),
                  parseInt(arg1) + parseInt(arg2)
                )
              : "",
        };
        break;

      case "tolowercase":
        returnObject = {
          code: "ToLowercase",
          result:
            typeof input_value == "string" ? input_value.toLowerCase() : "",
        };
        break;

      case "touppercase":
        returnObject = {
          code: "ToUppercase",
          result:
            typeof input_value == "string" ? input_value.toUpperCase() : "",
        };
        break;

      case "trim":
        returnObject = {
          code: "Trim",
          result: typeof input_value == "string" ? input_value.trim() : "",
        };
        break;

      case "trimleading":
        returnObject = {
          code: "TrimLeading",
          result: typeof input_value == "string" ? input_value.trimStart() : "",
        };
        break;

      case "trimtrailing":
        returnObject = {
          code: "TrimTrailing",
          result: typeof input_value == "string" ? input_value.trimEnd() : "",
        };
        break;

      case "concat":
        returnObject = {
          code: "Concat",
          result:
            typeof input_value == "string" && typeof arg1 == "string"
              ? input_value + arg1.slice(1, -1)
              : "",
        };
        break;

      case "defaultoption":
        var temp_ = null;
        if (!input_value) {
          temp_ = arg1.slice(1, -1);
        } else {
          temp_ = input_value;
        }

        returnObject = {
          code: "DefaultOption",
          result: temp_,
        };
        break;

      case "replace":
        returnObject = {
          code: "Replace",
          result:
            typeof input_value == "string" &&
            typeof arg1 == "string" &&
            typeof arg2 == "string" &&
            input_value == arg1.slice(1, -1)
              ? arg2.slice(1, -1)
              : input_value,
        };
        break;

      case "replacelookup":
        let temp = null;
        if (
          typeof input_value == "string" &&
          typeof arg1 == "string" &&
          typeof arg2 == "string"
        ) {
          let temp_arg1 = arg1;
          temp_arg1 = temp_arg1.replace("[", "");
          temp_arg1 = temp_arg1.replace("]", "");
          temp_arg1 = temp_arg1.split(",");
          temp_arg1 = temp_arg1.map((e) => e.slice(1, -1));
          let temp_arg2 = arg2;
          temp_arg2 = temp_arg2.replace("[", "");
          temp_arg2 = temp_arg2.replace("]", "");
          temp_arg2 = temp_arg2.split(",");
          temp_arg2 = temp_arg2.map((e) => e.slice(1, -1));

          if (temp_arg1.includes(input_value)) {
            temp = temp_arg2[temp_arg1.indexOf(input_value)];
          }
        } else if (!isEmpty(arg1) && !isEmpty(arg2)) {
          let temp_arg1 = arg1.toString();
          temp_arg1 = temp_arg1.replace("[", "");
          temp_arg1 = temp_arg1.replace("]", "");
          temp_arg1 = temp_arg1.split(",");
          temp_arg1 = temp_arg1.map((e) => e.slice(1, -1));
          let temp_arg2 = arg2.toString();
          temp_arg2 = temp_arg2.replace("[", "");
          temp_arg2 = temp_arg2.replace("]", "");
          temp_arg2 = temp_arg2.split(",");
          temp_arg2 = temp_arg2.map((e) => e.slice(1, -1));
          if (temp_arg1.includes(input_value)) {
            temp = temp_arg2[temp_arg1.indexOf(input_value)];
          }
        }
        returnObject = {
          code: "ReplaceLookup",
          result: temp,
        };
        break;

      case "todate":
        let todate_ = "";
        //         let temp_input_value=null;
        //        if(isNumber(input_value))
        //        {
        // temp_input_value = input_value.toString().substring(0,2) + '/' + input_value.toString().substring(2,4) + '/' + input_value.toString().substring(4,8)
        //        }
        //        else{
        //         temp_input_value=input_value;
        //        }

        todate_ = [
          "MM/dd/yyyy",
          "dd/MM/yyyy",
          "yyyy/MM/dd",
          "MM/dd/yy",
          "dd/MM/yy",
          "yy/MM/dd",
          "MMddyyyy",
          "ddMMyyyy",
          "yyyyMMdd",
          "MMddyy",
          "ddMMyy",
          "yyMMdd",
        ].includes(arg1.slice(1, -1))
          ? moment(
              input_value.toString().trim(),
              arg1.slice(1, -1).toUpperCase()
            )
              .format("YYYY-DD-MM hh:mm:ss")
              .toString()
          : "";
        // includes(arg1.slice(1, -1))

        returnObject = {
          code: "ToDate",
          result: todate_ == null ? "" : todate_,
        };
        break;

      case "startofmonth":
        // let temp1 = input_value;
        // temp1 = temp1.split("");
        // temp1[2] = "0";
        // temp1[3] = "1";
        // temp1 = temp1.join("");
        returnObject = {
          code: "StartOfMonth",
          result: moment().startOf("month").format("MMDDYYYY"),
        };
        break;

      case "endofthemonth":
        returnObject = {
          code: "EndOfTheMonth",
          result: moment().endOf("month").format("MMDDYYYY"),
        };
        break;

      case "today":
        returnObject = {
          code: "Today",
          result: moment().format("MMDDYYYY"),
        };
        break;

      case "elapsedyear":
        let elapsedYear = "";
        let admission = moment(input_value);
        let discharge = moment(arg1, "MM/DD/YYYY");
        let diff = admission.diff(discharge, "years");
        if (admission.isValid && discharge.isValid && diff) {
          elapsedYear = diff;
        }
        returnObject = {
          code: "ElapsedYear",
          result: elapsedYear,
        };
        break;

      case "elapsedmonth":
        let elapsedMonth = "";
        let admission_ = moment(input_value);
        let discharge_ = moment(arg1, "MM/DD/YYYY");
        let diff_ = admission_.diff(discharge_, "months");
        if (admission_.isValid && discharge_.isValid && diff_) {
          elapsedMonth = diff_;
        }
        returnObject = {
          code: "ElapsedMonth",
          result: elapsedMonth,
        };
        break;

      case "elapsedday":
        let elapsedDays = "";
        let admission1 = moment(input_value);
        let discharge1 = moment(arg1, "MM/DD/YYYY");
        let diff1 = admission1.diff(discharge1, "days");
        if (admission1.isValid && discharge1.isValid && diff1) {
          elapsedDays = diff1;
        }
        returnObject = {
          code: "ElapsedDay",
          result: elapsedDays,
        };
        break;

      case "age":
        let ageValue = "";
        let admission2 = moment(input_value);
        let discharge2 = moment();
        let diff2 = discharge2.diff(admission2, "years");
        if (admission2.isValid && discharge2.isValid && diff2) {
          ageValue = diff2;
        }
        returnObject = {
          code: "Age",
          result: ageValue,
        };
        break;

      case "ageason":
        try {
          let ageAsOn = "";
          let admission3 = moment(input_value);
          let discharge3 = moment(arg1, "MM/DD/YYYY");
          let diff3 = discharge3.diff(admission3, "years");
          if (admission3.isValid && discharge3.isValid && diff3) {
            ageAsOn = diff3;
          }
          returnObject = {
            code: "AgeAsOn",
            result: ageAsOn,
          };
        } catch {
          returnObject = {
            code: "AgeAsOn",
            result: "Error happend",
          };
        }
        break;

      default:
        returnObject = {
          result: "",
        };
        break;
    }
    return returnObject;
  };

  const getType = (val) => {
    if (!val) return val;
    if (typeof val === "number") return 2;
    else if (!isNaN(Date.parse(val))) return 4;
    else if (typeof val === "string") return 1;
    else return 3;
  };

  const getResult = (i, fuData, itemMapped, values, setFieldValue) => {
    const getResultFromSwitchCase = () => {
      let tempResult = null;
      let inputValue = null;
      if (!isEmpty(fuData) && !isEmpty(get(values, `fieldOperations[${i}]`))) {
        if (i !== 0) {
          inputValue = values.resultArray[i - 1].result;
        } else if (values[fields.pickDataFrom] === 1) {
          //inputValue = itemMapped.datum==''?'hello':itemMapped.datum;
          inputValue = itemMapped.datum;
        } else if (values[fields.pickDataFrom] === 2) {
          inputValue = itemMapped.fieldName.replace("/", "");
        } else if (values[fields.pickDataFrom] === 3) {
          inputValue = get(values, "constantValue", "");
        } else if (values[fields.pickDataFrom] === 6) {
          inputValue = fileName;
        }
        tempResult = switchView(
          fuData.label,
          inputValue,
          get(values.fieldOperations[i], "code0", ""),
          get(values.fieldOperations[i], "code1", ""),
          itemMapped
        ).result;
        //PROBLEM WITH FUNCTION
        if (values[`resultArray`][i]?.result != tempResult) {
          let temp_ = [...values.resultArray];
          temp_[i] = { result: tempResult };
          setFieldValue(`resultArray`, temp_);
        }
      }
      // else {
      //   tempResult = null;
      // }

      return tempResult;
    };

    let resultValue = getResultFromSwitchCase();
    if (resultValue == null && resultValue != values?.resultArray[i]?.result) {
      try {
        setFieldValue(`resultArray[${i}].result`, resultValue);
        setFieldValue(
          `resultArray[${i}].returnDataType`,
          fuData.returnDataType
        );
      } catch {}
    }
    return resultValue;
    // return tempResult;
  };

  const getFinalResultType = (values) => {
    const pickDataFrom = get(values, "pickDataFrom", 1);
    var results = get(values, "resultArray", null);
    if (
      results &&
      results.length == 1 &&
      results[results.length - 1]?.result == null
    )
      switch (pickDataFrom) {
        case 1:
          results = [{ result: itemMapped?.datum }];
          break;
        case 2:
          results = [{ result: itemMapped?.fieldName?.replace("/", "") }];
          break;
        case 3:
          results = [{ result: get(values, "constantValue", "") }];
          break;
        case 6:
          results = [{ result: get(values, "variableValue", "") }];
          break;
        default:
          results = get(values, "resultArray", []);
          break;
      }
    const finalResult = results.length
      ? results[results.length - 1]?.result
      : null;
    return getType(finalResult);
  };

  const setSave = (values) => {
    const filteredOp = get(values, "fieldOperations", {}).filter((e) => {
      if (!isEmpty(e?.function)) {
        return e;
      }
    });
    const operations =
      filteredOp &&
      filteredOp.map((e, i) => {
        // if (!isEmpty(e?.function)) {
        let indexOfTheFunction = functionList
          .map((f) => f.displayedName)
          .indexOf(e.function);
        let transform = null;
        if (
          !isNaN(indexOfTheFunction) &&
          indexOfTheFunction >= 0 &&
          indexOfTheFunction < functionList.length
        ) {
          transform =
            functionList[indexOfTheFunction].numberOfParameters == 0
              ? `${e.function}(source)`
              : functionList[indexOfTheFunction].numberOfParameters == 1
              ? `${e.function}(source,${e.code0})`
              : functionList[indexOfTheFunction].numberOfParameters == 2
              ? `${e.function}(source,${e.code0},${e.code1})`
              : null;
        }
        return {
          id: get(e, "id", 0),
          objectMapId: get(e, "objectMapId", 0),
          transformation:
            values[fields.pickDataFrom] === 3
              ? ""
              : !isEmpty(transform)
              ? transform
              : "",
          // constantValue: values.constantValue,
          [fields.pickDataFrom]: values[fields.pickDataFrom],
        };
        // }
      });
    if (isEmpty(itemId)) {
      const finalOutput = initialData.map((e) => {
        if (e.id == item.id) {
          return {
            ...e,
            fieldOperations: operations ? operations : [],
            dataSource: get(values, "pickDataFrom", 1),
            displayName: get(values, "targetFieldName", e.displayName),
            constantValue:
              values["pickDataFrom"] === 3
                ? get(values, "constantValue", "")
                : get(values, "variableValue", ""),
            transformedType: getFinalResultType(values),
            // variableValue: get(values, "variableValue", "")
          };
        }
        return e;
      });
      setTargetField(finalOutput);
    }
    if (!isEmpty(itemId)) {
      const output = initialData.map((e) => {
        if (e.id == itemId) {
          const childs = e.childObjectMaps.map((f) => {
            if (f.id == item.id) {
              return {
                ...f,
                fieldOperations: operations ? operations : [],
                dataSource: get(values, "pickDataFrom", 1),
                displayName: get(values, "targetFieldName", f.displayName),
                constantValue:
                  values["pickDataFrom"] === 3
                    ? get(values, "constantValue", "")
                    : get(values, "variableValue", ""),
                transformedType: getFinalResultType(values),
                // variableValue: get(values, "variableValue", "")
              };
            }
            return f;
          });
          return {
            ...e,
            childObjectMaps: childs,
          };
        }
        return e;
      });
      setTargetField(output);
    }
  };
  const EditorConsole = () => {
    return (
      <>
        <div className="form-group">
          <label for="codeTextArea" style={{ fontSize: "14px", color: "gray" }}>
            Code{" "}
            <span>
              <i className="far fa-question-circle"></i>
            </span>{" "}
          </label>

          <AceEditor
            style={{ width: "100%", height: "11.25rem" }}
            id="codeTextArea"
            mode="csharp"
            theme="terminal"
            onChange={(val) => {
              setEditorConsoleCode(val);
            }}
            name="UNIQUE_ID_OF_DIV"
            editorProps={{ $blockScrolling: true }}
            showPrintMargin={true}
            showGutter={true}
            highlightActiveLine={true}
            value={editorConsoleCode}
            setOptions={{
              enableBasicAutocompletion: true,
              enableLiveAutocompletion: true,
              enableSnippets: true,
              showLineNumbers: true,
              tabSize: 2,
            }}
          />
        </div>

        <div className="form-group">
          <label
            for="ResultTextArea"
            style={{ fontSize: "14px", color: "gray" }}
          >
            Result{" "}
          </label>
          <textarea
            className="form-control"
            id="ResultTextArea"
            rows="3"
            style={{ fontSize: "14px" }}
          ></textarea>
        </div>
      </>
    );
  };

  return (
    <Formik
      initialValues={{
        ...initialValues,
        fieldOperations: !isEmpty(functionTransformedData)
          ? functionTransformedData
          : [
              {
                function: "",
                returnDataType: null,
              },
            ],
        [fields.pickDataFrom]:
          get(item, "dataSource", 1) == 0 ? 1 : get(item, "dataSource", 1),
        // get(item, "dataSource", 1),
        constantValue:
          item["dataSource"] === 3 ? get(item, "constantValue", "") : "",
        variableValue:
          item["dataSource"] === 6 ? get(item, "constantValue", "") : "",
        targetFieldRename: item.displayName,
        targetFieldName: item.displayName,
        resultArray: !isEmpty(functionTransformedData)
          ? functionTransformedData.map(() => {
              return { result: null };
            })
          : [
              {
                result: null,
              },
            ],
      }}
      enableReinitialize
      onSubmit={(values) => {
        setSave(values);
        onCancel();
      }}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          setTouched,
          values,
          setSubmitting,
          touched,
          ...rest
        } = formProps;
        let lastDataType = values.fieldOperations.slice(-1)[0]?.returnDataType
          ? values.fieldOperations.slice(-1)[0]?.returnDataType
          : item.dataType;
        let checkDataType = lastDataType === item.dataType;
        return (
          <Form autoComplete="off" onSubmit={handleSubmit}>
            <SliderPanel
              isOpen={addFieldSlider}
              size="50"
              onClose={onCancel}
              showCancel={false}
              backdropClicked={() => setFieldSlider(false)}
            >
              <div className="inside-content mt-30">
                <div className="d-flex justify-content-between align-baseline">
                  <div>
                    <p className="investment-heading">
                      Configure Transformations
                    </p>
                  </div>
                  <div>
                    <Button variant="secondary" onClick={onCancel}>
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      className="ml-4"
                      // onClick={() => {
                      //   setSave(values);
                      //   onCancel();
                      // }}
                      type="submit"
                    >
                      Save
                    </Button>
                  </div>
                </div>
                <div className="break-bar"></div>
                <Form
                  autoComplete="off"
                  className="h-100"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="mt-3">
                    <div className="mb-2" style={{ display: "flex" }}>
                      <p
                        className="m-0 mr-2"
                        style={{ fontSize: "12px", fontWeight: "500" }}
                      >
                        {values.targetFieldName}
                      </p>
                      {get(item, "isRequired", false) ? (
                        <div
                          style={{
                            fontSize: "10px",
                            fontWeight: "400",
                            display: "flex",
                            alignSelf: "flex-end",
                          }}
                        >
                          (Required)
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                    <SourceFieldComponent item={itemMapped} />
                    <div className="d-flex mt-4">
                      <Field
                        style={{ width: "14.5rem" }}
                        name={`targetFieldName`}
                        type="text"
                        isRequired
                        label="Target Field Name"
                        size="sm"
                        value={values.targetFieldName}
                        component={FieldInput}
                      />
                    </div>
                    <div className="mt-3">
                      <Field
                        isRequired
                        name={fields.pickDataFrom}
                        label="Pick Data From"
                        options={toOptionValuesFromMapper(valueType)}
                        selectedValue={values[fields.pickDataFrom]}
                        autoComplete="off"
                        onChange={(value) => {
                          setFieldValue(fields.pickDataFrom, value);
                        }}
                        component={FieldButtonGroup}
                      />
                    </div>
                    {values[fields.pickDataFrom] === 3 ? (
                      <>
                        <div className="function-heading mb-4 mt-5">
                          Constant
                        </div>

                        {itemConfigure.object.dataType === 4 ? (
                          <Field
                            name={`constantValue`}
                            label="Value"
                            size="sm"
                            {...rest}
                            value={values["constantValue"]}
                            isDatePicker
                            isRequired
                            onClear={() =>
                              setFieldValue("constantValue", undefined)
                            }
                            popupContent={
                              <DatePicker
                                onDayClick={(value) =>
                                  setFieldValue(
                                    "constantValue",
                                    usDateFormat(value)
                                  )
                                }
                                value={values["constantValue"]}
                              />
                            }
                            component={FieldDropSide}
                          />
                        ) : (
                          <div className="d-flex">
                            <Field
                              style={{ width: "14.5rem" }}
                              name={`constantValue`}
                              type="text"
                              isRequired
                              label="Value"
                              size="sm"
                              // value={values.constantValue}
                              component={FieldInput}
                            />
                            <FontAwesomeIcon
                              style={{ marginTop: "40px", marginLeft: "10px" }}
                              icon={faTrashAlt}
                              size="20px"
                              color="#EB5757"
                              onClick={() => {
                                setFieldValue("constantValue", "");
                              }}
                            />
                          </div>
                        )}
                      </>
                    ) : values[fields.pickDataFrom] === 6 ? (
                      <>
                        <div className="function-heading mb-4 mt-5">
                          Variable
                        </div>
                        <div className="d-flex">
                          <Field
                            style={{ width: "14.5rem" }}
                            name={`variableValue`}
                            type="text"
                            isRequired
                            label="Value"
                            size="sm"
                            // value={values.constantValue}
                            component={FieldInput}
                          />
                          <FontAwesomeIcon
                            style={{ marginTop: "40px", marginLeft: "10px" }}
                            icon={faTrashAlt}
                            size="20px"
                            color="#EB5757"
                            onClick={() => {
                              setFieldValue("variableValue", "");
                            }}
                          />
                        </div>
                        <div className="d-flex mt-5">
                          <div className="function-heading">Function</div>
                          <p className="ft-14 black-text ml-5 mr-3">
                            <Form.Check
                              type="switch"
                              id={`custom-switch-1`}
                              label=" "
                              checked={ShowEditorConsole}
                              onChange={() => {
                                setShowEditorConsole(!ShowEditorConsole);
                              }}
                            />
                          </p>
                          <div className="Editor-heading">Editor Console</div>
                        </div>

                        <div>
                          {(() => {
                            if (ShowEditorConsole) {
                              return EditorConsole();
                            } else {
                              return (
                                <FieldArray name="fieldOperations">
                                  {(arrayhelpers) => (
                                    <>
                                      {values["fieldOperations"].map((e, i) => {
                                        const fieldOperationValues = get(
                                          values,
                                          `fieldOperations[${i}]`,
                                          ""
                                        );
                                        const fuData = functionData.find(
                                          (f) => f.displayedName === e.function
                                        );
                                        const codeFields = !isEmpty(fuData)
                                          ? !isEmpty(fuData.codebox)
                                            ? fuData.codebox.map((g, index) => (
                                                <div className="function-text-fields">
                                                  <Field
                                                    name={`fieldOperations[${i}].code${index}`}
                                                    id={`resultDisplay${i}code${index}`}
                                                    type="text"
                                                    isRequired
                                                    label={
                                                      fuData.parameters[index]
                                                        .code
                                                    }
                                                    size="sm"
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                      let temp_result = getResult(
                                                        i,
                                                        fuData,
                                                        itemMapped,
                                                        values,
                                                        setFieldValue
                                                      );
                                                      setFieldValue(
                                                        `resultArray[${i}].result`,
                                                        { temp_result }
                                                      );
                                                    }}
                                                    value={
                                                      !isEmpty(
                                                        get(
                                                          fieldOperationValues,
                                                          `code${index}`
                                                        )
                                                      )
                                                        ? get(
                                                            fieldOperationValues,
                                                            `code${index}`
                                                          )
                                                        : null
                                                    }
                                                    component={FieldInput}
                                                  />
                                                </div>
                                              ))
                                            : null
                                          : null;

                                        return (
                                          <>
                                            <div className="field-operation-functions">
                                              <div className="function-text-fields">
                                                <Field
                                                  name={`fieldOperations[${i}].function`}
                                                  label="Function Name"
                                                  options={functionData.filter(
                                                    (fun1) => {
                                                      if (i == 0) {
                                                        return (
                                                          fun1.dataType ==
                                                          itemMapped.type
                                                        );
                                                      } else {
                                                        return (
                                                          fun1.dataType ==
                                                          values[
                                                            `fieldOperations`
                                                          ][i - 1]
                                                            ?.returnDataType
                                                        );
                                                      }
                                                    }
                                                  )}
                                                  placeholder="Enter Function"
                                                  onSelect={(label, value) => {
                                                    setFieldValue(
                                                      `fieldOperations[${i}].function`,
                                                      label
                                                    );
                                                    let tempIndex = null;
                                                    for (let ind in functionData) {
                                                      if (
                                                        functionData[ind]
                                                          .displayedName ==
                                                        label
                                                      ) {
                                                        tempIndex = ind;
                                                      }
                                                    }
                                                    setFieldValue(
                                                      `fieldOperations[${i}].returnDataType`,
                                                      functionData[tempIndex]
                                                        ?.returnDataType
                                                    );
                                                  }}
                                                  isRequired
                                                  component={SearchDrop}
                                                />
                                              </div>
                                              {!isEmpty(fuData) && codeFields}
                                              <div>
                                                <FontAwesomeIcon
                                                  className="delete-function-icon  "
                                                  icon={faTrashAlt}
                                                  size="20px"
                                                  color="#EB5757"
                                                  onClick={() => {
                                                    const tempFieldOperations = [
                                                      ...values.fieldOperations,
                                                    ];
                                                    const tempResultArray = [
                                                      ...values.resultArray,
                                                    ];
                                                    tempResultArray.splice(
                                                      i,
                                                      1
                                                    );
                                                    tempFieldOperations.splice(
                                                      i,
                                                      1
                                                    );
                                                    setFieldValue(
                                                      `fieldOperations`,
                                                      tempFieldOperations
                                                    );
                                                    setFieldValue(
                                                      "resultArray",
                                                      tempResultArray
                                                    );
                                                  }}
                                                />
                                              </div>

                                              <div
                                                className={`function-result-field`}
                                              >
                                                <Field
                                                  name={`fieldOperations[${i}].result`}
                                                  type="text"
                                                  isRequired
                                                  label="Result"
                                                  size="sm"
                                                  disabled
                                                  value={
                                                    values[
                                                      "variableValue"
                                                    ].toLowerCase() ===
                                                    "@filename"
                                                      ? getResult(
                                                          i,
                                                          fuData,
                                                          itemMapped,
                                                          values,
                                                          setFieldValue
                                                        )
                                                      : null
                                                  }
                                                  component={FieldInput}
                                                />
                                              </div>
                                            </div>
                                          </>
                                        );
                                      })}
                                      <div
                                        className="add-custom-field-text"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          const tempResultArray = [
                                            ...values.resultArray,
                                          ];
                                          tempResultArray.push({
                                            result: null,
                                          });
                                          setFieldValue(
                                            "resultArray",
                                            tempResultArray
                                          );
                                          arrayhelpers.push({ function: "" });
                                        }}
                                      >
                                        Add More Functions
                                      </div>
                                    </>
                                  )}
                                </FieldArray>
                              );
                            }
                          })()}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="d-flex mt-5">
                          <div className="function-heading">Function</div>
                          <p className="ft-14 black-text ml-5 mr-3">
                            <Form.Check
                              type="switch"
                              id={`custom-switch-1`}
                              label=" "
                              checked={ShowEditorConsole}
                              onChange={() => {
                                setShowEditorConsole(!ShowEditorConsole);
                              }}
                            />
                          </p>
                          <div className="Editor-heading">Editor Console</div>
                        </div>

                        <div>
                          {(() => {
                            if (ShowEditorConsole) {
                              return EditorConsole();
                            } else {
                              return (
                                <FieldArray name="fieldOperations">
                                  {(arrayhelpers) => (
                                    <>
                                      {
                                        // (values["fieldOperations"][0].function!="") &&
                                        values["fieldOperations"].map(
                                          (e, i) => {
                                            const fieldOperationValues = get(
                                              values,
                                              `fieldOperations[${i}]`,
                                              ""
                                            );

                                            // if(e==null){
                                            //   setFieldValue(`fieldOperations[${i}]`, {function: '', returnDataType: null})
                                            //   e= {function: '', returnDataType: null}
                                            // }
                                            const fuData = functionData.find(
                                              (f) =>
                                                f.displayedName === e?.function
                                            );
                                            const codeFields = !isEmpty(fuData)
                                              ? !isEmpty(fuData.codebox)
                                                ? fuData.codebox.map(
                                                    (g, index) => (
                                                      <div className="function-text-fields">
                                                        <Field
                                                          name={`fieldOperations[${i}].code${index}`}
                                                          id={`resultDisplay${i}code${index}`}
                                                          type="text"
                                                          isRequired
                                                          label={
                                                            fuData.parameters[
                                                              index
                                                            ].code
                                                          }
                                                          size="sm"
                                                          onChange={(e) => {
                                                            handleChange(e);
                                                            let temp_result = getResult(
                                                              i,
                                                              fuData,
                                                              itemMapped,
                                                              values,
                                                              setFieldValue
                                                            );
                                                            setFieldValue(
                                                              `resultArray[${i}].result`,
                                                              { temp_result }
                                                            );
                                                          }}
                                                          value={
                                                            !isEmpty(
                                                              get(
                                                                fieldOperationValues,
                                                                `code${index}`
                                                              )
                                                            )
                                                              ? get(
                                                                  fieldOperationValues,
                                                                  `code${index}`
                                                                )
                                                              : null
                                                          }
                                                          component={FieldInput}
                                                        />
                                                      </div>
                                                    )
                                                  )
                                                : null
                                              : null;

                                            return (
                                              <>
                                                <div className="field-operation-functions">
                                                  <div className="function-text-fields">
                                                    <Field
                                                      name={`fieldOperations[${i}].function`}
                                                      label="Function Name"
                                                      options={functionData.filter(
                                                        (fun1) => {
                                                          if (
                                                            values.pickDataFrom ==
                                                            2
                                                          ) {
                                                            return (
                                                              fun1.dataType == 1
                                                            );
                                                          } else if (i == 0) {
                                                            return (
                                                              fun1.dataType ==
                                                              itemMapped.type
                                                            );
                                                          } else {
                                                            return (
                                                              fun1.dataType ==
                                                              values[
                                                                `fieldOperations`
                                                              ][i - 1]
                                                                ?.returnDataType
                                                            );
                                                          }
                                                        }
                                                      )}
                                                      placeholder="Enter Function"
                                                      onSelect={(
                                                        label,
                                                        value
                                                      ) => {
                                                        setFieldValue(
                                                          `fieldOperations[${i}].function`,
                                                          label
                                                        );
                                                        let tempIndex = null;
                                                        for (let ind in functionData) {
                                                          if (
                                                            functionData[ind]
                                                              .displayedName ==
                                                            label
                                                          ) {
                                                            tempIndex = ind;
                                                          }
                                                        }
                                                        setFieldValue(
                                                          `fieldOperations[${i}].returnDataType`,
                                                          functionData[
                                                            tempIndex
                                                          ]?.returnDataType
                                                        );
                                                        // setFieldValue(
                                                        //   `resultArray[${i}].returnDataType`,
                                                        //   functionData[tempIndex].returnDataType
                                                        // );
                                                      }}
                                                      isRequired
                                                      component={SearchDrop}
                                                      autoComplete="off"
                                                    />
                                                  </div>
                                                  {!isEmpty(fuData) &&
                                                    codeFields}
                                                  <div>
                                                    <FontAwesomeIcon
                                                      icon={faTrashAlt}
                                                      size="20px"
                                                      color="#EB5757"
                                                      className="delete-function-icon"
                                                      onClick={() => {
                                                        const tempFieldOperations = [
                                                          ...values.fieldOperations,
                                                        ];
                                                        const tempResultArray = [
                                                          ...values.resultArray,
                                                        ];
                                                        tempResultArray.splice(
                                                          i,
                                                          1
                                                        );
                                                        tempFieldOperations.splice(
                                                          i,
                                                          1
                                                        );
                                                        setFieldValue(
                                                          `fieldOperations`,
                                                          tempFieldOperations
                                                        );
                                                        setFieldValue(
                                                          "resultArray",
                                                          tempResultArray
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                  <div
                                                    className={`function-result-field`}
                                                  >
                                                    <Field
                                                      name={`fieldOperations[${i}].result`}
                                                      className={`${
                                                        i ===
                                                          values[
                                                            "fieldOperations"
                                                          ]?.length -
                                                            1 && !checkDataType
                                                          ? "border border-danger"
                                                          : ""
                                                      }`}
                                                      type="text"
                                                      isRequired
                                                      label="Result"
                                                      size="sm"
                                                      disabled
                                                      value={getResult(
                                                        i,
                                                        fuData,
                                                        itemMapped,
                                                        values,
                                                        setFieldValue
                                                      )}
                                                      component={FieldInput}
                                                    />
                                                    {i ===
                                                      values["fieldOperations"]
                                                        ?.length -
                                                        1 && !checkDataType ? (
                                                      <span className="errorMessage">
                                                        Datatype Mismatch
                                                      </span>
                                                    ) : null}
                                                  </div>
                                                </div>
                                              </>
                                            );
                                          }
                                        )
                                      }
                                      <div
                                        className="add-custom-field-text"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          const tempResultArray = [
                                            ...values.resultArray,
                                          ];
                                          tempResultArray.push({
                                            result: null,
                                          });
                                          setFieldValue(
                                            "resultArray",
                                            tempResultArray
                                          );
                                          arrayhelpers.push({ function: "" });
                                        }}
                                      >
                                        Add More Functions
                                      </div>
                                    </>
                                  )}
                                </FieldArray>
                              );
                            }
                          })()}
                        </div>
                      </>
                    )}
                  </div>
                </Form>
              </div>
            </SliderPanel>
          </Form>
        );
      }}
    </Formik>
  );
};
